/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:08:35
 * @LastEditTime: 2019-08-19 02:15:02
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
import './plugins/element.js'
import ElementUI from 'element-ui'
import './assets/css/index.less'
import './theme/index.css'
Vue.use(ElementUI)
import 'font-awesome/css/font-awesome.css'
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
import VueCookie from 'vue-cookie'
Vue.use(VueCookie)
Vue.use(axios);
import  VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
import {post,fetch,patch,put,del} from './until/http'
//定义全局变量
Vue.prototype.$cookies=VueCookie
Vue.prototype.$post=post;
Vue.prototype.$get=fetch;
Vue.prototype.$patch=patch;
Vue.prototype.$put=put;
Vue.prototype.$delete=del;

if (process.env.VUE_APP_type == 'development') {
    Vue.prototype.$Base_Export="http://logistics.c.smartcode.vip/admin/v2"
} else if (process.env.VUE_APP_type == 'production') {
    Vue.prototype.$Base_Export="https://logistics.smartcode.vip/admin/v2"
}else if(process.env.VUE_APP_type == 'person'){
    Vue.prototype.$Base_Export="http://logistics.tx315.vip/admin/v2"
}else if(process.env.VUE_APP_type == 'hd'){
    Vue.prototype.$Base_Export="https://qyhb-logistics.haid.com.cn/admin/v2"
}else if(process.env.VUE_APP_type == 'ym'){
    Vue.prototype.$Base_Export="https://logistics.ymsaas.com/admin/v2"
}else if(process.env.VUE_APP_type == 'ncbu'){
    Vue.prototype.$Base_Export="https://logistics.ncbu.cn/admin/v2"
}else if(process.env.VUE_APP_type == 'kjifen'){
    Vue.prototype.$Base_Export="https://logistics.keleshuma.com/admin/v2"
}else if(process.env.VUE_APP_type == 'dy'){
    Vue.prototype.$Base_Export="https://logistics.dayanga.net/admin/v2"
}else if(process.env.VUE_APP_type == 'qs'){
    Vue.prototype.$Base_Export="https://logistics.qsfw.net/admin/v2"
}else if(process.env.VUE_APP_type == 'kmd'){
    Vue.prototype.$Base_Export="https://logistics.s106.xcx008.com/admin/v2"
}else if(process.env.VUE_APP_type == 'wj'){
    Vue.prototype.$Base_Export="https://logistics.wjkj907.cn/admin/v2"
}else if(process.env.VUE_APP_type == 'ry'){
    Vue.prototype.$Base_Export="https://logistics.fwmcx.com/admin/v2"
}else if(process.env.VUE_APP_type == 'bcx'){
    Vue.prototype.$Base_Export="https://logistics.baochengxin.com/admin/v2"
}else if(process.env.VUE_APP_type == 'tkkj'){
    Vue.prototype.$Base_Export="https://logistics.tksmys.com/admin/v2"
}else{
    Vue.prototype.$Base_Export="http://logistics.cn2de.com/admin/v2"
}
localStorage.setItem('access_tokens',VueCookie.get('access_tokens'))
import Moment from 'moment';
Vue.prototype.moment=Moment;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
